import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { useCustomerValue } from "providers/CustomerContext";
import { useState, useEffect,useMemo } from "react";
import {
  getCycleCountList2,
  getCycleNoList,
  retrieveCycleCountListOnly,
  updateCCountList,
  getCycOpnBalScan,
  getCycOpnBalScanComparison,
  getCycOpnBalScan3,
  uploadCycOpnBalScanComparison,
  updateFinalCCountList,
  ccforceclose,
  ccconsolidate,
  retrieveCCountSummaryLookup,
  retrieveLatestCCountList,
  getadjustmentreasoncode,
} from "services/data.inventory.service";
import { LoadingDialog } from "ui-components/Alert";
import BasicTabs from "ui-components/tabs/BasicTabs";
import { InboundLayout } from "ui-components/Layout";
import { InboundHeaderCard } from "ui-components/Layout";
import { FormTitle, InboundSubmitButton } from "ui-components/Form";
import { Grid,Icon } from "@mui/material";
import { SelectFields } from "ui-components/Form";
import { Fieldset } from "ui-components/Form";
import { TableCard } from "ui-components/Layout";
import { FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import BasicTable from "ui-components/tables/BasicTable";
import { Formik, Form } from "formik";
import { uploadCC } from "services/data.inventory.service";
import { cycleCountListcolumns, cycleCountListLookup } from "./columns";
import { Success, Error_ ,ExportDialog } from "ui-components/Alert";
import { EditableSelect, EditableNumber } from "ui-components/EditableInput2";
import { getVendorSKUList2 } from "services/data.internal.service";
import CheckboxTable2 from "ui-components/tables/CheckboxTable2";
import { useTeamValue } from "providers/TeamContext";
import { Texts } from "ui-components/Form";
import MDTypography from "components/MDTypography";
import useCsvDownloadHook from "hooks/useCsvDownloadHook";
import { StripedDataGrid } from "ui-components/data-grids/StripedCheckboxDataGrid";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import AddCycleCountDialog from "./dialog";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";


function UpdateCycleCount({ zoneLocationAisle }) {
  const { permissions, allowAll } = useTeamValue();
  const editPermission =
    allowAll ||
    (Boolean(permissions["Cycle Count"]) &&
      permissions["Cycle Count"].findIndex((b) => b === "edit") !== -1);
  const { customerCode } = useCustomerValue();
  console.log(customerCode);
  const { cCountNo } = useState("");
  const [alert, setAlert] = useState(null);
  const [status, setStatus] = useState("");
  const [cnos, setCNOs] = useState([]);
  const [selectedCNO, setSelectedCNO] = useState(null);
  //const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);
  const onError = (error, setAlert) => {
    setAlert(null); // Clear any existing alert
    setAlert(<Error_ data={error} onChange={setAlert} />);
  };
  const onSuccess = (data, setAlert) => {
    setAlert(null); // Clear any existing alert
    setAlert(<Success data={data} onChange={setAlert} />);
  };
  const tabs = ["Cycle Count List", "Count Summary Lookup", "Latest Count Data", "Consolidate"];
  //const uploadCCMutation = useMutation(uploadCC, {});
  const uploadCCMutation = useMutation(uploadCC, {
    onSuccess: (data) => {
      document.getElementById("files").value = null;
      setUploadResps(data.data.data);
      onSuccess(data, setAlert);
    },
    onError: (error) => onError(error, setAlert),
  });
  const uploadStatus = uploadCCMutation.status === "loading";
  const [uploadResps, setUploadResps] = useState([]);
  const { isFetchingCNo, refetch: refetchCNo } = useQuery({
    queryKey: ["CNOOption", { customerCode }],
    queryFn: () => getCycleNoList(customerCode),
    enabled: true,
    onSuccess: (data) => {
      if (data && data.data) {
        setCNOs(data.data.data);
      }
    },
    //onError,
    onError: (error) => onError(error, setAlert),
  });

  const getcyclecountMutation = useMutation((requestdata) => getCycleCountList2(requestdata), {
    onSuccess: (data) => {
      const { cCountNo } = data.data;
      console.log("CCountNo:", cCountNo);
      retrieveCycleCountListOnly(cCountNo).then((response) => {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${cCountNo}.xlsx`);
        document.body.appendChild(link);
        link.click();
      });
      // queryClient.invalidateQueries(["exception-list"]);
      // setAlert(<Success data={data} onChange={setAlert} />);
    },
    //onError,
    onError: (error) => onError(error, setAlert),
  });

  const handleDownload = () => {
    console.log(selectedCNO); // Log the selected value
    // Add code here to handle the download
    retrieveCycleCountListOnly(selectedCNO).then((response) => {
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${selectedCNO}.xlsx`);
      document.body.appendChild(link);
      link.click();
    });
  };

  const handleSubmit = (values, actions) => {
    setAlert(null);
    let formData = new FormData();
    formData.append("files", values.files[0], values.files[0].name);
    formData.append("customerCode", customerCode);
    formData.append("CCountNo", selectedCNO);
    formData.append("vendorCode", values.vendorCode);
    uploadCCMutation.mutate(formData, {
      onSuccess: (data) => {
        console.log("Success response:", data); // Log success response
        document.getElementById("files").value = null;
        //  document.getElementById("files").value = null;
        //  actions.setFieldValue("vendorCode", "");
        //  actions.resetForm();
        setUploadResps(data.data.data);
        //setAlert(<Success content="File is uploaded successfully." onChange={setAlert} />);
        const uploadData = data.data.data; 
        if (uploadData.length > 0) {
          setAlert(<Error_ content="Please refer to the excel file for the issue." onChange={setAlert} />);
      } else {
          setAlert(<Success content="File is uploaded successfully." onChange={setAlert} />);
      }
      },
      //onError,
      onError: async (data) => {
        // let content = await data.response.data.text();
        // if (content.includes("No data")) {
        //   content = "No data";
        // }
        setAlert(<Error_ content={"Please refer to the excel file for the issue."} onChange={setAlert} />);
      },
      // onError: (error) => {
      //   console.error("Error response:", error);
      //   const errorMessage =
      //     error.response?.data?.message ||
      //     "There is problem with uploaded file. Please check carefully.";
      //   onError(error, setAlert);
      //   setAlert(<Error_ data={error} onChange={setAlert} />);
      // },
    });
    actions.setSubmitting(false);
    // actions.resetForm(true);
  };

  const {downloadCsv, isDownloading} = useCsvDownloadHook();

  useEffect(() => {
    refetchCNo(); // Trigger the query to fetch data
  }, []);

  useEffect(() => {
      if (uploadResps.length > 0) {
        const filename = `${customerCode}_${dayjs(new Date()).format("YYYYMMDD-HHmm")}_Cyclecount`;
        const headers = [
          { label: "Cycle Count No", key: "cCountNo" },
          { label: "Customer Code", key: "customerCode" },
          { label: "SKU Code", key: "skuCode" },
          { label: "Zone Id", key: "zoneID" },
          { label: "Location Id", key: "locationID" },
          { label: "Carton Id", key: "cartonID" },
          { label: "Quantity", key: "sysQty" },
          { label: "MLN", key: "mln" },
          { label: "Retail Barcode", key: "retailBarcode" },
          { label: "Expiry Date", key: "expiryDate" },
          { label: "Message", key: "message" },
        ];
    
        // Auto download CSV
        downloadCsv(filename, uploadResps.filter((x) => !x.success), headers);
      }
    }, [uploadResps]);

  const render = () => {
    let task;
    switch (status) {
      case "Cycle Count List":
        console.log("cnos value:", selectedCNO);
        console.log("customerCode value:", customerCode);
        task = (
          <CCountList
            //columns={columns}
            customerCode={customerCode}
            cnos={selectedCNO}
            // userOptions={userOptions}
            // szOptions={szOptions}
            // categoryOptions={categoryOptions}
            // list={list}
            // setList={setList}
            // onPreallocate={onPreallocate}
            // setAlert={setAlert}
            editPermission={editPermission}
          />
        );
        break;

      case "Count Summary Lookup":
        task = (
          <CCountSummaryLookUp
            customerCode={customerCode}
            cnos={selectedCNO}
            onError={onError}
            editPermission={editPermission}
          />
        );
        break;
      case "Latest Count Data":
        task = (
          <CountData
            customerCode={customerCode}
            cnos={selectedCNO}
            onError={onError}
            editPermission={editPermission}
          />
        );
        break;
      case "Consolidate":
        task = (
          <Consolidate
            customerCode={customerCode}
            cnos={selectedCNO}
            onError={onError}
            refetchCNo={refetchCNo}
            editPermission={editPermission}
            setSelectedCNO = {setSelectedCNO}
          />
        );
        break;
      case "Allocation Queue":
        task = <AllocationQueue customerCode={customerCode} />;
        break;
      case "Demo":
        task = <Demo2 customerCode={customerCode} />;
        break;
    }

    return task;
  };

  return (
    <InboundLayout lg={12}>
      {alert}
      {isDownloading && <ExportDialog />}
      <InboundHeaderCard>
        <FormTitle title={"Update Cycle Count"} />
        <MDBox display="flex">
          <Fieldset label="Please choose a cycle count to proceed">
            <Grid container spacing={3}>
              <Grid item xs={4}>
                <SelectFields
                  field={{
                    name: "",
                    label: "",
                    value: selectedCNO,
                    errors: {},
                  }}
                  options={cnos}
                  onChange={(e, v) => setSelectedCNO(v)}
                />
              </Grid>

              <Grid item xs={1.5}>
                <MDButton
                  color="info"
                  variant="gradient"
                  onClick={handleDownload}
                  disabled={selectedCNO === null || selectedCNO.trim() === ""}
                >
                  Download CountSheet
                </MDButton>
              </Grid>
            </Grid>
          </Fieldset>
          <Fieldset sx={{ marginLeft: "1rem" }} label="Upload cycle count data">
            <Formik initialValues={{ files: [] }} onSubmit={handleSubmit}>
              {({ values, setFieldValue }) => (
                <Form>
                  <MDBox>
                    <input
                      type="file"
                      name="files"
                      id="files"
                      onChange={(e) => {
                        setUploadResps([]);
                        setFieldValue("files", e.target.files);
                      }}
                    />
                    <MDButton
                      style={{ marginLeft: "3rem" }}
                      type="submit"
                      variant="gradient"
                      color="info"
                      disabled={
		       values.files.length == 0 ||
                        uploadStatus ||
                        selectedCNO === null ||
                        selectedCNO.trim() === ""

                        //(values.files.length == 0 ||
                        //  uploadStatus ||
                        //  selectedCNO === null ||
                        //  selectedCNO.trim() === "") &&
                        //!editPermission
                      }
                    >
                      {uploadStatus ? "Uploading" : "Upload"}
                    </MDButton>
                  </MDBox>
                </Form>
              )}
            </Formik>
            {/* <Grid item xs={1.5}>
                  <MDButton color="info" variant="gradient" onClick={handleDownload}>
                    Upload
                  </MDButton>
                </Grid> */}
          </Fieldset>
        </MDBox>
      </InboundHeaderCard>
      <InboundHeaderCard>
        <BasicTabs tabs={tabs} status={status} setStatus={setStatus} />

        <MDBox>{render()}</MDBox>
      </InboundHeaderCard>
    </InboundLayout>
  );
}

const StatusIcon = ({ color, icon }) => (
  <MDButton color={color} variant="outlined" size="small" iconOnly circular>
    <Icon sx={{ fontWeight: "bold" }}>{icon}</Icon>
  </MDButton>
);

export default UpdateCycleCount;

function CCountList({ cnos, customerCode, zoneID, onError, editPermission }) {
  const [list, setList] = useState([]);
  const [data, setData] = useState([]);
  const queryClient = useQueryClient();
  const [alert, setAlert] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [columnFilter, setColumnFilter] = useState([{ id: "zoneID", value: zoneID }]);
  // const { isFetching, refetch } = useQuery({
  //   queryKey: ["cycopnbalscan-details"],
  //   queryFn: () => getCycOpnBalScan({ customerCode, cnos }),
  //   enabled: !!cnos,
  //   onSuccess: (data) => setList(data.data.data),
  //   onError: (data) => {
  //     setAlert(<Error data={data} onChange={setAlert} />);
  //   },
  // });

  const handleDownload = () => {
  const statusLabels = {
    C: "Data Uploaded",
    P: "Complete Scanning",
    O: "In Scanning",
  };

  const exportRows = filteredData.map((row) => {
    const rowData = {};
    cycleCountListcolumns.forEach((col) => {
      const value = row[col.accessorKey];
      if (col.accessorKey === "status") {
        rowData[col.header] = statusLabels[value] ?? value ?? "";
      } else {
        rowData[col.header] = col.exportFormat ? col.exportFormat(value) : value ?? "";
      }
    });
    return rowData;
  });

  const worksheet = XLSX.utils.json_to_sheet(exportRows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Cycle Count List");
  XLSX.writeFile(workbook, "CycleCountList.xlsx");
  };

  const [originalList, setOriginalList] = useState([]);

const { isFetching, refetch } = useQuery({
  queryKey: ["cycopnbalscan-details"],
  queryFn: () => getCycOpnBalScan({ customerCode, cnos }),
  enabled: !!cnos,
  onSuccess: (data) => {
    setList(data.data.data);
    setOriginalList(data.data.data.map((row) => ({ ...row })));
  },
  onError: (data) => {
    setAlert(<Error data={data} onChange={setAlert} />);
  },
});

  useEffect(() => {
    if (cnos) {
      refetch(); // Refetch data whenever pnos changes
    }
  }, [cnos, refetch]);

  const updateCCountListMutation = useMutation(updateCCountList, {
    onSuccess: (list) => {
      queryClient.invalidateQueries(["count-list"]);
      setAlert(<Success data={list} onChange={setAlert} />);
    },
    //onError,
    onError: (data) => {
      console.log(data);
      setAlert(<Error_ data={data} onChange={setAlert} />);
    },
  });

  

  // const onSubmit = () => {
  //   console.log(list);
  //   updateCCountListMutation.mutate(list);
  // };
  

const onSubmit = () => {
  const changedRows = list.filter((row, index) => {
    const original = originalList[index];
    return original && row.countQty !== original.countQty;
  });

  if (changedRows.length === 0) {
    setAlert(<Error_ data={{ message: "No changes to update" }} onChange={setAlert} />);
    return;
  }

  updateCCountListMutation.mutate(changedRows);
};
const handleretrieve = () => {
    refetch();
  };
  const [openAddDialog, setOpenAddDialog] = useState(false);

  return (
    <>
      {isFetching && <LoadingDialog />}
      {alert}
      <TableCard sx={{ mt: "1rem" }}>
        <MDBox display="flex" justifyContent="space-between" alignItems="flex-start" margin="10px">
          <MDBox display="flex" gap={1}>
            <MDButton
            color="info"
            variant="gradient"
            onClick={handleretrieve}
            disabled={cnos === null || cnos.trim() === ""}
            sx={{ mr: 2 }}
          >
            Retrieve
          </MDButton>
          <MDButton
            color="info"
            variant="gradient"
            onClick={handleDownload}
            disabled={customerCode === null}
            sx={{ mr: 2 }}
          >
            Export
          </MDButton>
           <MDButton
             color="info"
             variant="gradient"
             onClick={() => setOpenAddDialog(true)}
             sx={{ mr: 2 }}
           >
             Add Row
           </MDButton>
           </MDBox>
          <MDBox
      sx={{
        backgroundColor: "#f8d7da", // Light red background
        color: "#721c24", // Dark red text
        padding: "10px",
        borderRadius: "5px",
        fontSize: "14px",
        fontWeight: "bold",
        display: "inline-block",
      }}
    >
      You are not allowed to modify data here after uploading count data.
    </MDBox>
        </MDBox>
        <CheckboxTable2 data={list} columns={cycleCountListcolumns} setData={setList}  onFilterRowsChange={setFilteredData}/>
      </TableCard>
      <AddCycleCountDialog
  open={openAddDialog}
  onClose={() => setOpenAddDialog(false)}
  onSave={(row) => {
    setList(prev => [...prev, row]);
  }}
  customerCode={customerCode}
  zoneID={zoneID}
  cCountNo={cnos}
  setAlert={setAlert}
/>
      <InboundSubmitButton label="Update" onClick={onSubmit} disabled={!editPermission} />
    </>
  );
}

function CCountSummaryLookUp({ cnos, customerCode, editPermission }) {
  const [list, setList] = useState([]);
  const [type, setType] = useState("ALL");
  const [alert, setAlert] = useState(null);
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  console.log(cnos);
  const { isFetching, refetch } = useQuery({
    queryKey: ["cycopnbalscan-details", type],
    queryFn: () => getCycOpnBalScanComparison({ cnos, type, customerCode }),
    enabled: !!cnos,
    onSuccess: (data) => setList(data.data.data),
    onError,
  });
  const [filteredData, setFilteredData] = useState([]);
  useEffect(() => {
    if (cnos) {
      refetch(); // Refetch data whenever pnos changes
    }
  }, [cnos, refetch]);

  // const handleDownload = () => {
  //   retrieveCCountSummaryLookup({ cnos, type, customerCode }).then((response) => {
  //     const blob = new Blob([response.data], {
  //       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //     });
  //     const url = window.URL.createObjectURL(blob);
  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.setAttribute("download", `CCountSummaryLookup.xlsx`);
  //     document.body.appendChild(link);
  //     link.click();
  //   });
  // };

  const handleDownload = () => {
    const exportRows = filteredData.map((row) => {
      const rowData = {};
      cycleCountListLookup.forEach((col) => {
        rowData[col.header] = col.exportFormat ? col.exportFormat(row[col.accessorKey]) : row[col.accessorKey] ?? "";
      });
      return rowData;
    });

    const worksheet = XLSX.utils.json_to_sheet(exportRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Count Summary");
    XLSX.writeFile(workbook, "CCountSummaryLookup.xlsx");
  };

  const [openPdfDialog, setOpenPdfDialog] = useState(false);
const [pdfTitle, setPdfTitle] = useState("Count Summary Lookup");
const [selectedColumns, setSelectedColumns] = useState(
  cycleCountListLookup.map((col) => col.accessorKey)
);

const handleColumnToggle = (key) => {
  setSelectedColumns((prev) =>
    prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
  );
};

const handleExportPDF = () => {
  const doc = new jsPDF({ orientation: "landscape" });
  const pageWidth = doc.internal.pageSize.getWidth();

  doc.setFontSize(14);
  doc.setFont(undefined, "bold");
  doc.text(pdfTitle, 14, 15);

  doc.setFontSize(10);
  doc.setFont(undefined, "normal");
  doc.text(`Cycle Count No : ${cnos || ""}`, 14, 21);

  const now = new Date();
  const formattedDate = now.toLocaleString("en-US", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  }).replace(",", "");

  doc.setFontSize(10);
  doc.text(`Date : ${formattedDate}`, pageWidth - 14, 12, { align: "right" });

  const columnsToExport = cycleCountListLookup.filter((col) =>
    selectedColumns.includes(col.accessorKey)
  );

  const head = [columnsToExport.map((col) => col.header)];
  const body = filteredData.map((row) =>
    columnsToExport.map((col) => col.exportFormat ? col.exportFormat(row[col.accessorKey]) : row[col.accessorKey] ?? "")
  );

  autoTable(doc, {
    head,
    body,
    startY: 28,
    styles: { fontSize: 8 },
    headStyles: { fillColor: [26, 115, 232] },
  });

  const finalY = doc.lastAutoTable.finalY || 28;
  const pageHeight = doc.internal.pageSize.getHeight();

  let footerY = finalY + 10;
  if (footerY > pageHeight - 15) {
    doc.addPage();
    footerY = 15;
  }
  doc.setFontSize(9);
  doc.setFont(undefined, "bold");
  doc.text(`Total SysQty: ${totals.sysQty}`, 14, footerY);
  doc.text(`Total CountQty: ${totals.countQty}`, 80, footerY);
  doc.text(`Total Variance: ${totals.variance}`, 150, footerY);

  doc.save(`${pdfTitle.replace(/\s+/g, "_")}.pdf`);
  setOpenPdfDialog(false);
};

  const createConsigneeMutation = useMutation(
    ({ cnos, type, customerCode }) => uploadCycOpnBalScanComparison({ cnos, type, customerCode }),
    {
      onSuccess: (data) => setAlert(<Success data={data} onChange={setAlert} />),
      onError,
    }
  );
 const createConsigneeMutationStatus = createConsigneeMutation.status === "loading"
  const onSubmit = () => {
    createConsigneeMutation.mutate(
      { cnos, type, customerCode },
      {
        onSuccess: () =>
          //reset(),
          {},
      }
    );
  };

  const tableProps = {
    data: list,
    columns: cycleCountListLookup,
  };

  const totals = useMemo(() => {
    return list.reduce(
      (acc, item) => {
        acc.sysQty += item.sysQty || 0;
        acc.countQty += item.countQty || 0;
        acc.variance += item.variance || 0;
        return acc;
      },
      { sysQty: 0, countQty: 0, variance: 0 } // Initial values
    );
  }, [list]);

  return (
    <>
    <TableCard sx={{ mt: "1rem" }}>
      {(isFetching || createConsigneeMutationStatus) && <LoadingDialog />}
      {alert}
      <Grid sx={{ padding: "10px 0 0 10px" }} container spacking={3} justifyContent="space-between">
        <Grid item>
          <MDButton
            color="info"
            variant="gradient"
            onClick={onSubmit}
            disabled={(list.length === 0 || type !== "ALL") && !editPermission}
            sx={{ mr: 2 }}
          >
            Upload Count Data
          </MDButton>
            <MDButton
            color="info"
            variant="gradient"
            onClick={handleDownload}
            disabled={customerCode === null}
            sx={{ mr: 2 }}
          >
            Export Excel
          </MDButton>
          <MDButton
  color="info"
  variant="gradient"
  onClick={() => setOpenPdfDialog(true)}
  disabled={customerCode === null}
  sx={{ mr: 2 }}
>
  Export PDF
</MDButton>
          </Grid>
          <Grid item sx={{ textAlign: "right", display: "flex", gap: "2rem" }}>
    <div>
      <strong>Total SysQty:</strong> {totals.sysQty}
    </div>
    <div>
      <strong>Total CountQty:</strong> {totals.countQty}
    </div>
    <div>
      <strong>Total Variance:</strong> {totals.variance}
    </div>
  </Grid>
        
      </Grid>
      <Grid sx={{ paddingLeft: "12px" }} container spacing={3}>
        <Grid item>
          <FormControl>
            <RadioGroup
              row
              onChange={(e) => {
                setType(e.target.value);
              }}
            >
              <FormControlLabel
                labelPlacement="left"
                value="ALL"
                label="All"
                control={
                  <Radio
                    sx={{ "& .MuiSvgIcon-root": { border: "1px solid #1A73E8" } }}
                    checked={type === "ALL"}
                  />
                }
              />
              <FormControlLabel
                labelPlacement="left"
                value="POSITIVE"
                label="Variance"
                control={
                  <Radio
                    sx={{ "& .MuiSvgIcon-root": { border: "1px solid #1A73E8" } }}
                    checked={type === "POSITIVE"}
                  />
                }
              />
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
      <BasicTable {...tableProps} onFilterRowsChange={setFilteredData} />
    </TableCard>
    <Dialog open={openPdfDialog} onClose={() => setOpenPdfDialog(false)} maxWidth="xs" fullWidth>
      <DialogTitle>Export to PDF</DialogTitle>
      <DialogContent>
        <TextField
          margin="dense"
          label="PDF Title"
          fullWidth
          value={pdfTitle}
          onChange={(e) => setPdfTitle(e.target.value)}
          sx={{ mb: 2 }}
        />
        <strong>Select Columns</strong>
        <FormGroup>
          {cycleCountListLookup.map((col) => (
            <FormControlLabel
              key={col.accessorKey}
              control={
                <Checkbox
                  checked={selectedColumns.includes(col.accessorKey)}
                  onChange={() => handleColumnToggle(col.accessorKey)}
                />
              }
              label={col.header}
            />
          ))}
        </FormGroup>
      </DialogContent>
      <DialogActions>
        <MDButton color="secondary" variant="gradient" onClick={() => setOpenPdfDialog(false)}>
          Cancel
        </MDButton>
        <MDButton
          color="info"
          variant="gradient"
          onClick={handleExportPDF}
          disabled={selectedColumns.length === 0}
        >
          Export
        </MDButton>
      </DialogActions>
    </Dialog>
    </>
  );
}

function CountData({ cnos, customerCode, zoneID, onError, editPermission }) {
  const [list, setList] = useState([]);
  const queryClient = useQueryClient();
  const [alert, setAlert] = useState(null);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [vendorOptions, setVendorOptions] = useState([]);
  const active = true;
  const [columnFilter, setColumnFilter] = useState([{ id: "zoneID", value: zoneID }]);
  const { isFetching, refetch } = useQuery({
    queryKey: ["cycopnbalscan-details"],
    queryFn: () => getCycOpnBalScan3({ cnos, customerCode }),
    enabled: !!cnos,
    onSuccess: async (data) => {
      const listData = data.data.data;
      console.log("Fetched listData:", listData);
      // setList(listData);
      // const skuCodes = listData.map(item => item.skuCode); // Extract skuCodes from the list
      // console.log("skucodes" , skuCodes);
      // fetchVendorList(skuCodes); // Fetch vendor list using skuCodes
      const updatedList = await Promise.all(
        listData.map(async (item) => {
          const skuCode = item.skuCode;
          console.log("Processing skuCode:", skuCode);

          try {
            const vendorOptions = await fetchVendorList(skuCode);
            return {
              ...item,
              vendorOptions, // Add vendorOptions to each item
            };
          } catch (error) {
            console.error(`Error fetching vendor list for SKU ${skuCode}`, error);
            return item; // Return the original item if fetch fails
          }
        })
      );

      // Update the list with vendor options
      setList(updatedList);
      // Loop through each SKU code and fetch vendor options
      // const updatedList = await Promise.all(
      //   listData.map(async (item) => {
      //     const skuCode = item.skuCode;
      //     console.log("skucode inside updatedlist" , skuCode);
      //     try {
      //       const response = await getVendorSKUList2({ customerCode, skuCode: [skuCode], active });
      //       const vendorOptions = response.data.data.map(vendor => ({
      //         label: vendor.vendorCode,
      //         value: vendor.vendorCode
      //       }));

      //       // Add vendor options to the current item
      //       return {
      //         ...item,
      //         vendorOptions
      //       };
      //     } catch (error) {
      //       console.error(`Error fetching vendor list for SKU ${skuCode}`, error);
      //       return item; // Return the original item if the fetch fails
      //     }
      //   })
      // );

      // // Update the list with vendor options
      // setList(updatedList);
    },
    //onSuccess: (data) => setList(data.data.data),
    onError,
  });

  const updateFinalCountListMutation = useMutation(updateFinalCCountList, {
    onSuccess: (list) => {
      queryClient.invalidateQueries(["count-list2"]);
      setAlert(<Success data={list} onChange={setAlert} />);
      refetch();
    },
    onError,
  });

  const onSubmit = () => {
    console.log("beforewrap", list);
    const validatedList = list.map((item) => ({
      ...item,
      vendorCode: item.vendorCode?.value || item.vendorCode,
    }));
    console.log("validatedlist", validatedList);
    updateFinalCountListMutation.mutate(validatedList);
  };

  const handleretrieve = () => {
    refetch();
  };

  useEffect(() => {
    if (cnos) {
      refetch(); // Refetch data whenever pnos changes
    }
  }, [cnos, refetch]);

  const fetchVendorList = async (skuCode) => {
    try {
      const response = await getVendorSKUList2({ customerCode, skuCode, active });
      console.log("Vendor list response:", response); // Log the response
      //setVendorOptions(response.data.data.map(vendor => ({
      return response.data.data.map((vendor) => ({
        label: vendor.vendorCode, // Adjust based on actual vendor properties
        value: vendor.vendorCode, // Adjust based on actual vendor properties
      }));
    } catch (error) {
      console.error("Error fetching vendor list", error);
      // Handle error appropriately
    }
  };

  //   fetchVendorList();
  // }, []);

  const handleVendorCodeChange = (value, rowIndex) => {
    setList((prevList) => {
      const newList = [...prevList];
      newList[rowIndex] = {
        ...newList[rowIndex],
        vendorCode: { label: value, value: value },
      };
      return newList;
    });
  };

  // const handleDownload = () => {
  //   retrieveLatestCCountList({ cnos, customerCode }).then((response) => {
  //     const blob = new Blob([response.data], {
  //       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //     });
  //     const url = window.URL.createObjectURL(blob);
  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.setAttribute("download", `LatestCCountList.xlsx`);
  //     document.body.appendChild(link);
  //     link.click();
  //   });
  // };
  const handleDownload = () => {
  retrieveLatestCCountList({ cnos, customerCode, data: filteredData }).then((response) => {
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `LatestCCountList.xlsx`);
    document.body.appendChild(link);
    link.click();
  });
};

  const latestCountListcolumns2 = [
    {
      header: "Zone ID",
      accessorKey: "zoneID",
    },
    {
      header: "Location ID",
      accessorKey: "locationID",
    },
    {
      header: "Carton Id",
      accessorKey: "cartonID",
    },
    {
      header: "Vendor Code",
      accessorKey: "vendorCode",
      // cell: (props) => {
      //   const { row } = props;
      //   const options = row.original.vendorOptions || []; // Use vendor options specific to this row's SKU code
      //   return EditableSelect({
      //     ...props,
      //     options,
      //     value: props.cell.getValue()?.value,
      //   });
      // },
    },
    {
      header: "SKU Code",
      accessorKey: "skuCode",
    },
    {
      header: "Sys Qty",
      accessorKey: "sysQty",
    },
    {
      header: "Count Qty",
      accessorKey: "phyQty",
      ...{ cell: EditableNumber },
    },
    {
      header: "Variance",
      accessorKey: "variance",
    },
    {
      header: "MLN",
      accessorKey: "mln",
    },
    {
      header: "Expiry Date",
      accessorKey: "expiryDate",
      cell: ({ getValue }) => {
        const dateValue = getValue();
        if (!dateValue) {
          return ""; // Return empty string if the expiry date is null or empty
        }
        const formattedDate = new Date(dateValue).toLocaleDateString("en-GB"); // Format the date to "DD/MM/YYYY" or based on the user's locale
        return formattedDate;
      },
    },
  ];

  const [openPdfDialog, setOpenPdfDialog] = useState(false);
const [pdfTitle, setPdfTitle] = useState("Latest Count Data");
const [selectedColumns, setSelectedColumns] = useState(
  latestCountListcolumns2.map((col) => col.accessorKey)
);

const handleColumnToggle = (key) => {
  setSelectedColumns((prev) =>
    prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
  );
};

const handleExportPDF = () => {
  const doc = new jsPDF({ orientation: "landscape" });
  const pageWidth = doc.internal.pageSize.getWidth();

  doc.setFontSize(14);
  doc.setFont(undefined, "bold");
  doc.text(pdfTitle, 14, 15);

  doc.setFontSize(10);
  doc.setFont(undefined, "normal");
  doc.text(`Cycle Count No : ${cnos || ""}`, 14, 21);

  const now = new Date();
  const formattedDate = now
    .toLocaleString("en-US", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    })
    .replace(",", "");

  doc.setFontSize(10);
  doc.text(`Date : ${formattedDate}`, pageWidth - 14, 12, { align: "right" });

  const columnsToExport = latestCountListcolumns2.filter((col) =>
    selectedColumns.includes(col.accessorKey)
  );

  const head = [columnsToExport.map((col) => col.header)];
  const body = filteredData.map((row) =>
    columnsToExport.map((col) => {
      const value = row[col.accessorKey];
      if (col.accessorKey === "expiryDate") {
        return value ? new Date(value).toLocaleDateString("en-GB") : "";
      }
      if (col.accessorKey === "vendorCode") {
        return value?.value || value || "";
      }
      return value ?? "";
    })
  );

  autoTable(doc, {
    head,
    body,
    startY: 28,
    styles: { fontSize: 8 },
    headStyles: { fillColor: [26, 115, 232] },
  });

  const finalY = doc.lastAutoTable.finalY || 28;
  const pageHeight = doc.internal.pageSize.getHeight();

  let footerY = finalY + 10;
  if (footerY > pageHeight - 15) {
    doc.addPage();
    footerY = 15;
  }

  doc.setFontSize(9);
  doc.setFont(undefined, "bold");
  doc.text(`Total SysQty: ${totals.sysQty}`, 14, footerY);
  doc.text(`Total CountQty: ${totals.phyQty}`, 80, footerY);
  doc.text(`Total Variance: ${totals.variance}`, 150, footerY);

  doc.save(`${pdfTitle.replace(/\s+/g, "_")}.pdf`);
  setOpenPdfDialog(false);
};

  console.log("from latestcountdata",list);
  const totals = useMemo(() => {
    return list.reduce(
      (acc, item) => {
        acc.sysQty += Number(item.sysQty) || 0;
        acc.phyQty += Number(item.phyQty) || 0;
        acc.variance += Number(item.variance) || 0;
        return acc;
      },
      { sysQty: 0, phyQty: 0, variance: 0 } // Initial values
    );
  }, [list]);

  return (
    <>
      {isFetching && <LoadingDialog />}
      {alert}
      <TableCard sx={{ mt: "1rem" }}>
        <MDBox display="flex" justifyContent="space-between" alignItems="flex-start" margin="10px">
          <div>
          {/* <MDButton
            color="info"
            variant="gradient"
            onClick={handleDownload}
            disabled={customerCode === null}
            sx={{ mr: 2 }}
          >
            Export
          </MDButton> */}
          <MDButton
    color="info"
    variant="gradient"
    onClick={handleDownload}
    disabled={customerCode === null}
    sx={{ mr: 2 }}
  >
    Export Excel
  </MDButton>
  <MDButton
    color="info"
    variant="gradient"
    onClick={() => setOpenPdfDialog(true)}
    disabled={customerCode === null}
    sx={{ mr: 2 }}
  >
    Export PDF
  </MDButton>
          </div>
           {/* Right Section: Quantities */}
  <div style={{ display: "flex", gap: "2rem", textAlign: "right" }}>
    <div>
      <strong>Total SysQty:</strong> {totals.sysQty}
    </div>
    <div>
      <strong>Total CountQty:</strong> {totals.phyQty}
    </div>
    <div>
      <strong>Total Variance:</strong> {totals.variance}
    </div>
  </div>
        </MDBox>

        <CheckboxTable2 data={list} columns={latestCountListcolumns2} setData={setList}  onFilterRowsChange={setFilteredData}/>
      </TableCard>
      <Dialog open={openPdfDialog} onClose={() => setOpenPdfDialog(false)} maxWidth="xs" fullWidth>
  <DialogTitle>Export to PDF</DialogTitle>
  <DialogContent>
    <TextField
      margin="dense"
      label="PDF Title"
      fullWidth
      value={pdfTitle}
      onChange={(e) => setPdfTitle(e.target.value)}
      sx={{ mb: 2 }}
    />
    <strong>Select Columns</strong>
    <FormGroup>
      {latestCountListcolumns2.map((col) => (
        <FormControlLabel
          key={col.accessorKey}
          control={
            <Checkbox
              checked={selectedColumns.includes(col.accessorKey)}
              onChange={() => handleColumnToggle(col.accessorKey)}
            />
          }
          label={col.header}
        />
      ))}
    </FormGroup>
  </DialogContent>
  <DialogActions>
    <MDButton color="secondary" variant="gradient" onClick={() => setOpenPdfDialog(false)}>
      Cancel
    </MDButton>
    <MDButton
      color="info"
      variant="gradient"
      onClick={handleExportPDF}
      disabled={selectedColumns.length === 0}
    >
      Export
    </MDButton>
  </DialogActions>
</Dialog>
      <InboundSubmitButton label="Update" onClick={onSubmit} disabled={!editPermission} />
    </>
  );
}

function Consolidate({ cnos, customerCode, zoneID, onError, refetchCNo, editPermission, setSelectedCNO }) {
  const [list, setList] = useState([]);
  //const [filteredData, setFilteredData] = useState([]);
  //const [columnFilter, setColumnFilter] = useState([{ id: "zoneID", value: zoneID }]);
  const [alert, setAlert] = useState(null);
  const [reasoncodes, setReasonCodes] = useState([]);
  const [selectedReasonCode, setSelectedReasonCode] = useState("");

  const { isFetching, refetch } = useQuery({
    queryKey: ["cycopnbalscan-details",{cnos}],
    queryFn: () => getCycOpnBalScan({ customerCode, cnos }),
    enabled: !!cnos,
    onSuccess: (data) => setList(data.data.data),
    //onError,
    onError: (error) => onError(error, setAlert),
  });

  const consolidateMutation = useMutation(ccconsolidate, {
    onSuccess: (data) => {
      setAlert(<Success data={data} onChange={setAlert} />);
      setSelectedReasonCode(null);
      refetchCNo();
      setSelectedCNO(null);
    },
    //onError,
    onError: (error) => onError(error, setAlert),
  });

  const consolidateMutationStatus = consolidateMutation.status === "loading"
  console.log(consolidateMutation.status);
  const onconsolidate = () => {
    console.log({ cnos, customerCode });
    consolidateMutation.mutate({ cnos, customerCode, reasonCode: selectedReasonCode.value });
  };

//  useEffect(() => {
//    if (cnos) {
//      refetch(); // Refetch data whenever pnos changes
//    }
//  }, [cnos, refetch]);

  const forcecloseMutation = useMutation(ccforceclose, {
    onSuccess: (data) => {
      setAlert(<Success data={data} onChange={setAlert} />);
      setSelectedReasonCode(null);
      refetchCNo;
      setSelectedCNO(null);
    },
    //onError,
    onError: (error) => onError(error, setAlert),
  });

  const forcecloseMutationStatus = forcecloseMutation.status === "loading"

  const onforceclose = () => {
    console.log({ cnos, customerCode });
    forcecloseMutation.mutate({ cnos, customerCode });
  };

  const { refetch: refetchReasonCode } = useQuery({
    queryKey: ["ReasonCodeOption"],
    queryFn: () => getadjustmentreasoncode(),
    enabled: false,
    onSuccess: (data) => {
      console.log(data);
      setReasonCodes(
        data.data.data.map((item) => ({
          label: item.description1, // Adjust this to the column you want to display
          value: item.id, // Or any other identifier you need
        }))
      );
    },
    onError: (error) => onError(error, setAlert),
  });

  useEffect(() => {
    refetchReasonCode(); // Fetch reason codes when the component mounts
  }, [refetchReasonCode]);

  return (
    <>
      {(isFetching || consolidateMutationStatus || forcecloseMutationStatus) && <LoadingDialog />}
      {alert}
      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        sx={{ mt: "0.2rem", mb: "0.2rem" }}
      >
        <Grid item xs={12}>
          <SelectFields
            field={{
              name: "",
              label: "Reason Code",
              value: selectedReasonCode,
              errors: {},
            }}
            options={reasoncodes}
            onChange={(e, v) => {
              console.log("Selected Reason Code:", v); // Log the selected reason code
              setSelectedReasonCode(v);
            }}
          />
        </Grid>
      </Grid>
      <MDButton
        color="info"
        variant="gradient"
        onClick={onconsolidate}
        disabled={
          (!selectedReasonCode ||
                 selectedReasonCode.value === null ||
                 selectedReasonCode.value.trim() === "" ||
                 cnos === null ||
                 cnos.trim() === ""||
                    consolidateMutationStatus)
        }
        // disabled={
        //   (!selectedReasonCode ||
        //     selectedReasonCode.value === null ||
        //     selectedReasonCode.value.trim() === "" ||
        //     cnos === null ||
        //     cnos.trim() === "") &&
        //   !editPermission
        // }
        style={{ marginRight: "1rem" }}
      >
        Consolidate
      </MDButton>
      <MDButton
        color="info"
        variant="gradient"
        onClick={onforceclose}
        disabled={( cnos === null || cnos.trim() === "" || forcecloseMutationStatus)}
        //disabled={(cnos === null || cnos.trim() === "") && !editPermission}
      >
        Force Close
      </MDButton>
    </>
  );
}
